export default "__VITE_ASSET__BYyGgE38__"